import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loginComponent from './login.component';
import myBookingApi from '../../../api/mybooking/mybooking';
import languageService from '../../../services/language.service';
import cacheService from '../../../services/cache.service';

const loginModule = angular.module('onTheBeachLogin', [
    uiRouter,
    myBookingApi,
    cacheService,
    languageService
])
    .config(($stateProvider, $urlMatcherFactoryProvider) => {
        "ngInject";

        $urlMatcherFactoryProvider.strictMode(false);
        $stateProvider
            .state('onTheBeach.login', {
                url: '/login?reference&surname',
                views: {
                    'main@': {
                        template: '<on-the-beach-login></on-the-beach-login>'
                    }
                }
            });
    })
    .component('onTheBeachLogin', loginComponent)
    .name;

export default loginModule;



// WEBPACK FOOTER //
// ./client/app/routes/onTheBeach/login/login.js